<template>
  <div class="theme-head">
    <div class="theme-box">
      <h3
        class="theme-title"
        :style="{
          backgroundImage: 'url(' + titleBg + ')',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center'
        }"
      >
        <!-- <span class="striping"></span>{{ title }}<span class="striping"></span> -->
      </h3>
      <div class="theme-intro" v-if="more === '进入应用'">
        {{ intro }}
        <span class="theme-more theme-more-color" v-show="!isLink" @click="createPro"
          >{{ more }}<i>&gt;</i></span
        >
        <span class="" @click="openNewWindow">
          <router-link v-show="isLink" class="theme-more theme-more-color" :to="redirect"
            >{{ more }}<i>&gt;</i></router-link
          >
        </span>
      </div>
      <div class="theme-intro" v-else>
        {{ intro }}
        <span class="theme-more" v-show="!isLink" @click="createPro"
          >{{ more }}<i>&gt;</i></span
        >
        <span class="" @click="openNewWindow">
          <router-link v-show="isLink" class="theme-more" :to="redirect"
            >{{ more }}<i>&gt;</i></router-link
          >
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "theme-head",
  components: {},
  props: {
    isLink: {
      type: Boolean,
      default: true
    },
    title: String,
    intro: String,
    more: String,
    redirect: String,
    titleBg: String,
    openUrl: String
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    createPro(evt) {
      this.$emit("myProject", evt);
    },
    openNewWindow() {
      if (this.openUrl === "experinceAi") { 
         const { href } = this.$router.resolve({
            path: `/experian/index`,
          });
          window.open(href,"_blank")
        // window.open("../../../../modules/experianceAI/index.html");
      } else if (this.openUrl === "application") {
        this.$router.push({
          name: "application-index",
          query: {}
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.theme-title {
  padding: 79px 0 4px;
  font-size: 30px;
  margin-bottom: 25px;
  color: #000001;
  font-weight: normal;
  .striping {
    display: inline-block;
    width: 40px;
    height: 1px;
    background-color: #f00;
    background-color: #c7ced5;
    margin: 10px 28px;
  }
}
.theme-box {
  width: 1200px;
  margin: 0 auto;
  padding-top: 52px;
  padding-bottom: 36px;
}

.training-project .theme-intro,
.training-apply .theme-intro {
  color: #333;
  // color: #c2c4ff;
}
.training-project a.theme-more,
.training-apply a.theme-more {
  // color: #c2c4ff;
}

.theme-intro {
  position: relative;
  font-size: 18px;
  color: #333;
  margin-bottom: 50px;
  .theme-more {
    position: absolute;
    right: 0;
    font-size: 16px;
    // color: #4784ff;
    color: #fff;
    z-index: 2;
    cursor: pointer;

    &:hover {
      color: #fff;
    }
  }

  .theme-more-color {
    color: #333;
  } 
}
</style>
